import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
} from "../services/types/ComponentTypes";

export const screen_167_reports: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Reports",
    style: {},
    childComponents: [
      {
        componentType: ComponentType.SUMMARY_LIST,
        Name: "Reports",
        apiname: "Reports",
        BindValue: "grid_reports",
        titleValue: "Reports",
        DisplayName: "Reports",
        // EnableReport flag to indicate this is a report module
        EnableReport: true,
        Plugged_json: "Reports.json",
        PluggingType: "Report",
        SummeryActions: [],
        Form: {
          Name: "Reports",
          DisplayName: "Reports",
          Workflow: null,
          Fields: [
            {
              IncludeLabel: true,
              Label: "Report name",
              BindValue: "txt_report_name",
              Json_Attribute: "ReportName",
              ControlType: "TextView",
              showInSummary: true,
              IsPrimary: false,
            },
          ],
        },
      },
    ],
  },
];
